export default __webpack_public_path__ + "static/media/workouttimes_6.08f828c5.jpg";